var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-tmap-audit" },
    [
      _c(
        "yxt-form",
        { attrs: { "label-position": "top", "label-width": "auto" } },
        [
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_tmap_lbl_name").d("层级地图名称"),
              },
            },
            [_c("p", [_vm._v(_vm._s(_vm.mapDetails.trainMapName))])]
          ),
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_detail_lbl_introduction").d("简介"),
              },
            },
            [_c("p", [_vm._v(_vm._s(_vm.mapDetails.description || "-"))])]
          ),
        ],
        1
      ),
      !_vm.isSignup
        ? _c("xxbiz-signup", {
            attrs: { mod: "info", id: _vm.id },
            on: { callback: _vm.callback },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }